/*
 * Shared client for the generic hero_node config endpoint:
 * POST /config/fetchServiceConfig  body: { config_type, service_name, source }
 *
 * Any screen can fetch its own app_configurations document through this one
 * helper instead of a bespoke per-feature API call. Resolves to the raw axios
 * response; response.data is:
 *   { config_type, service_name, source, found, version, config }
 * `config` is null when no active document exists for the tuple — callers
 * should fall back to their own local default configuration in that case.
 */
var redirectURL = require('../redirectURL');

export function fetchServiceConfig({ config_type, service_name, source }) {
	return redirectURL.post('/config/fetchServiceConfig', {
		config_type: config_type,
		service_name: service_name,
		source: source || 'ui'
	});
}

export default fetchServiceConfig;
